import { useContext, useEffect, useState } from "react"
import { AuthContext } from "../../contexts/auth"

/**
 * @return {{user: {roles: string[] | null }}}
 */
export const useLoggedUser = () => {
  const { user } = useContext(AuthContext)
  const [loggedUser, setLoggedUser] = useState(null)

  useEffect(() => {
    const userData = !user
      ? undefined
      : {
        email: user?.email,
        user_id: user?.user_id,
        photoUrl: user?.photoUrl,
        displayName: user?.displayName,
        regions: user?.claims?.regions || [],
        roles: user?.claims?.role?.split(" ") || []
      }

      setLoggedUser(userData)
  }, [user])

  return {
    user: loggedUser
  }
}
